import React from 'react';

// A video link from YouTube or Facebook becomes a player on the page; any other link becomes a button.
export const embedUrl = (url) => {
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, '');
    let id = null;
    if (host === 'youtu.be') id = u.pathname.slice(1);
    else if (host.endsWith('youtube.com')) {
      if (u.pathname === '/watch') id = u.searchParams.get('v');
      else if (/^\/(embed|shorts|live)\//.test(u.pathname)) id = u.pathname.split('/')[2];
    }
    if (id && /^[A-Za-z0-9_-]{6,20}$/.test(id)) return `https://www.youtube-nocookie.com/embed/${id}`;
    if (host.endsWith('facebook.com') || host === 'fb.watch') {
      return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=false`;
    }
  } catch (e) {
    // not a web address
  }
  return null;
};

const VideoEmbed = ({ url, title }) => {
  const src = embedUrl(url);
  if (!src) {
    return (
      <a className="ed-btn-square" href={url} target="_blank" rel="noreferrer">
        <span>Watch the video</span>
      </a>
    );
  }
  return (
    <div className="sc-video">
      <iframe src={src} title={title || 'Video'} loading="lazy" allow="encrypted-media; picture-in-picture" allowFullScreen></iframe>
    </div>
  );
};

export default VideoEmbed;
